import { Space } from "antd";
import { FaAngleDown } from "react-icons/fa6";
import { MdDelete, MdEdit, MdOutlineRemoveRedEye } from "react-icons/md";
import LinkButton from "../Buttons/LinkButtons";

const Actions = ({
  isEdit = false,
  isDelete = false,
  isActive = false,
  isWatchVideo = false,
  isAssignedTo = false,
  isLeadStatus = false,
  isView = false,
  isTrack = false,
  viewLabel = "",
  recordActiveStatus = false,
  onClickTrack = () => {},
  onClickEdit = () => {},
  onClickDelete = () => {},
  onClickWatchVideo = () => {},
  onClickActive = () => {},
  onClickView = () => {},
  onClickAssignedTo = () => {},
  onClickLeadStatus = () => {},
}) => {
  return (
    <Space>
      {isAssignedTo && (
        <LinkButton
          props={{
            label: "Assigned To",
            postfix: true,
            className: "text-danger p-2",
            onClick: onClickAssignedTo,
            icon: <FaAngleDown className="drop-down-arrow" />,
          }}
        />
      )}
      {isLeadStatus && (
        <LinkButton
          props={{
            label: "Lead Status",
            postfix: true,
            className: "text-danger p-2",
            onClick: onClickLeadStatus,
            icon: <FaAngleDown className="drop-down-arrow" />,
          }}
        />
      )}
      {isActive && (
        <LinkButton
          props={{
            label: !recordActiveStatus ? "Inactive" : "Active",
            postfix: true,
            className: `${recordActiveStatus ? "text-success" : "text-warning"} mx-2 cursor-pointer`,
            onClick: onClickActive,
          }}
        />
      )}
      {isEdit && (
        <LinkButton
          props={{
            label: "Edit",
            prefix: true,
            icon: <MdEdit className="text-blue" size={15} />,
            className: "text-blue p-2",
            onClick: onClickEdit,
          }}
        />
      )}
      {isDelete && (
        <LinkButton
          props={{
            className: "text-primarycolor mx-2 cursor-pointer",
            label: "Delete",
            icon: <MdDelete className="text-primarycolor" size={15} />,
            prefix: true,
            onClick: onClickDelete,
          }}
        />
      )}
      {isView && (
        <LinkButton
          props={{
            className: "text-success mx-2 cursor-pointer",
            label: "View",
            icon: <MdOutlineRemoveRedEye className="text-success" size={15} />,
            prefix: true,
            onClick: onClickView,
          }}
        />
      )}
      {viewLabel && (
        <LinkButton
          props={{
            className: "text-success mx-2 cursor-pointer",
            label: viewLabel,
            icon: <MdOutlineRemoveRedEye className="text-success" size={15} />,
            prefix: true,
            onClick: onClickView,
          }}
        />
      )}
      {isWatchVideo && (
        <LinkButton
          props={{
            className: "master-edit  mx-2  mx-2",
            onClick: onClickWatchVideo,
            label: "Watch Video",
          }}
        />
      )}
      {isTrack && (
        <LinkButton
          props={{
            label: "Track",
            className: "text-warning mx-2",
            onClick: onClickTrack,
          }}
        />
      )}
    </Space>
  );
};

export default Actions;
